<div class="download-app-wrapper position-fixed p-3 w-100">
    <div class="d-flex align-items-center justify-content-between download-app-child">
        <p class="mb-0">{{'app-download.title' | translate}}</p>
        <button class="btn" (click)="openAppLink()">{{'app-download.download' | translate}}</button>
    </div>
</div>
